import { PaymentItemProps } from '@msc-b2c/interfaces/types';
import { Image } from '../image/Image';
import { RadioButton } from '../radiobutton/RadioButton';
import styles from './paymentsection/paymentsection.module.scss';

export const PaymentItem = ({
  id,
  images,
  checked,
  onTypeClick,
  type,
  price,
  paymentMethod,
  ariaLabel,
}: PaymentItemProps) => {
  return (
    <div className={`${styles['cmp-paymentCardItem']}`}>
      {images.map((image) => (
        <Image
          key={`${id}_${image}`}
          src={image}
          alt={id}
          styleOption={''}
        />
      ))}
      <RadioButton
        id={id + '_item' + type}
        name={type}
        value={id}
        checked={checked}
        onChange={() => onTypeClick(paymentMethod, price, type)}
        ariaLabel={ariaLabel}
      />
    </div>
  );
};
